import { Select } from "antd";
import { FC, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { getExamSubjects } from "../../api/statistics.api";
import useAxios from "../../hooks/useAxios";
import { IGetExamSubjects } from "../../models/statistics.model";
import ErrorResponse from "../ErrorResponse";
import Loader from "../Loader";

interface IProps {
  examCode: number|undefined;
  examSubjectCode: number|undefined;
  setExamSubjectCode: (examSubjectCode: number) => void;
  setExamSubjectName?: (examSubjectName: string) => void;
}

const SelectExamSubject: FC<IProps> = ({
  examCode,
  examSubjectCode,
  setExamSubjectCode,
  setExamSubjectName
}) => {
  const { t } = useTranslation();
  const { data: res, isLoading, error, execute } = useAxios<IGetExamSubjects>();

  useEffect(() => {
    if (examCode) {
      execute(getExamSubjects(examCode));
    }
  }, [examCode]);

  return (
    <>
      {/*sLoading && <Loader />*/}
      <ErrorResponse error={error} />

      <Select
        className="w-100"
        placeholder={t('statistics.regularTest.placeholder3')}
        value={examSubjectCode}
        onChange={(value, options) => {
          setExamSubjectCode(value)
          if(setExamSubjectName){
            Object.entries(options).map(([key, value])=>{
              if(key === 'subjectName') {
                setExamSubjectName(value);
              }
            });
          }
        }}
      >
        {examCode && res?.data?.map((item) => (
          <Select.Option
            key={item.examSubjectCode}
            value={item.examSubjectCode}
            subjectName={item.subjectName}
          >
            {item.subjectName}
          </Select.Option>
        ))}
      </Select>
    </>
  );
}

export default SelectExamSubject;
